import { render, staticRenderFns } from "./main-producing.vue?vue&type=template&id=22980ff7&scoped=true&"
import script from "./main-producing.vue?vue&type=script&lang=js&"
export * from "./main-producing.vue?vue&type=script&lang=js&"
import style0 from "./main-producing.vue?vue&type=style&index=0&id=22980ff7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22980ff7",
  null
  
)

export default component.exports